<template>
  <ion-page>
    <Header title="Sản phẩm">
      <ion-toolbar color="light" v-if="isLogin">
        <ion-label slot="start" style="margin-left: 2vw" v-if="isLogin">
          {{ greeting }}
        </ion-label>
        <ion-buttons slot="end" style="background-color: #333; color: #dedede; border-radius: 50px">
          <ion-label style="margin-left: 2vw" v-if="isLogin">
            Số dư: <strong>{{ $utils.numberFormat(totalBalance) }}</strong> &nbsp;
          </ion-label>
          <ion-button color="warning" fill="solid" shape="round" @click="$router.push('/account/deposit/payment')">Nạp</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </Header>
    <ion-content>
      <div v-if="loaded && authService.binded" style="margin-top: 15px;">
        <ion-slides
          class="main-slider"
          ref="slider"
          pager="true"
          :options="slideOpts"
          v-if="banners.length > 0"
        >
          <ion-slide v-for="banner in banners" :key="banner.id">
            <img :src="banner.attachment.url" @click="bannerClick(banner.url)" />
          </ion-slide>
        </ion-slides>
        <div class="ion-padding" style="padding-top: 0">
          <ul>
            <li v-for="game in games" :key="game.id">
              <button @click="selectGame(game.id)" class="ion-activatable">
                <div class="game" :data-game="game.id">
                  <div class="logo">
                    <img
                      :src="require('../../images/games/' + game.id + '.png')"
                      :alt="game.id"
                    />
                    <div class="border"></div>
                  </div>
                  <div class="brief">
                    <div class="keno" v-if="game.id == 'keno'">
                      <div>Cơ hội trúng</div>
                      <h3>2 đến 10 Tỷ</h3>
                      <div>&nbsp;</div>
                    </div>

                    <div
                      class="power"
                      :class="todayPower"
                      v-if="game.id == 'power'"
                    >
                      <div>Jackpot trị giá</div>
                      <h3 style="text-transform: capitalize">
                        {{ jackpot($store.state.fsdb.livePower.jackpot1) }}
                      </h3>
                      <div class="countdown">
                        <ion-icon :icon="timeOutline"></ion-icon>&nbsp;{{
                          powerCountDown
                        }}
                      </div>
                      <ion-badge class="badge" color="danger"
                        >HÔM NAY</ion-badge
                      >
                    </div>

                    <div
                      class="mega"
                      :class="todayMega"
                      v-if="game.id == 'mega'"
                    >
                      <div>Jackpot trị giá</div>
                      <h3 style="text-transform: capitalize">
                        {{ jackpot($store.state.fsdb.liveMega.jackpot) }}
                      </h3>
                      <div class="countdown">
                        <ion-icon :icon="timeOutline"></ion-icon>&nbsp;{{
                          megaCountDown
                        }}
                      </div>
                      <ion-badge class="badge" color="danger"
                        >HÔM NAY</ion-badge
                      >
                    </div>

                    <div
                      class="max3d"
                      :class="todayMax3d"
                      v-if="game.id == 'max3d'"
                    >
                      <div>Giải thưởng</div>
                      <h3>x 100.000 Lần</h3>
                      <div class="countdown">
                        <ion-icon :icon="timeOutline"></ion-icon>&nbsp;{{
                          max3dCountDown
                        }}
                      </div>
                      <ion-badge class="badge" color="danger"
                        >HÔM NAY</ion-badge
                      >
                    </div>

                    <div
                      class="max3dpro"
                      :class="todayMax3dpro"
                      v-if="game.id == 'max3dpro'"
                    >
                      <div>Giải thưởng</div>
                      <h3>Trên 30 Tỷ</h3>
                      <div class="countdown">
                        <ion-icon :icon="timeOutline"></ion-icon>&nbsp;{{
                          max3dproCountDown
                        }}
                      </div>
                      <ion-badge class="badge" color="danger"
                        >HÔM NAY</ion-badge
                      >
                    </div>

                    <div
                      class="max4d"
                      :class="todayMax4d"
                      v-if="game.id == 'max4d'"
                    >
                      <div>Giải thưởng</div>
                      <h3>x 1.500 Lần</h3>
                      <div class="countdown">
                        <ion-icon :icon="timeOutline"></ion-icon>&nbsp;{{
                          max4dCountDown
                        }}
                      </div>
                      <ion-badge class="badge" color="danger"
                        >HÔM NAY</ion-badge
                      >
                    </div>

                    <div class="xskt" v-if="game.id == 'xskt'">
                      <div>Ngày ...</div>
                      <h3>Xổ Số Kiến Thiết</h3>
                    </div>
                  </div>
                </div>
                <ion-ripple-effect></ion-ripple-effect>
              </button>
            </li>
          </ul>
        </div>
      </div>
      <SupportButton :showBg="true"></SupportButton>
      <div style="height: 60px"></div>
    </ion-content>
    <ion-footer>
      <TabBar select="main"></TabBar>
    </ion-footer>
  </ion-page>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.main {
  flex-grow: 1;
  overflow: scroll;
  position: relative;
}

.tabbar {
  flex: 1;
}

.main-slider {
  height: 20vh;
}

.main-slider ion-slide {
  width: 90vw;
}

.main-slider ion-slide > :first-child {
  border-radius: 10px;
}

.game[data-game="keno"] {
  background: #fde8b5;
}
.game[data-game="power"] {
  background: #ffcb95;
}
.game[data-game="mega"] {
  background: #ffa995;
}
.game[data-game="max3d"] {
  background: #ffc0fe;
}
.game[data-game="max3dpro"] {
  background: #ff9aeb;
}
.game[data-game="max4d"] {
  background: #ff9aeb;
}
.game[data-game="xskt"] {
  background: #c7c8ff;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li {
  display: block;
  margin: 1.8vh 0vw;
}

ul li button {
  display: block;
  width: 100%;
  background: transparent;
  position: relative;
  outline: none !important;
  box-shadow: none !important;
  overflow: hidden;
}

.game {
  display: flex;
  height: 85px;
  position: relative;
  flex-direction: row;
  overflow: hidden;
}

.game .logo {
  width: 120px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.game .logo img {
  max-height: 60px;
  max-width: 90px;
  margin: 10px auto;
}

.game .brief {
  flex-grow: 1;
  position: relative;
  overflow: hidden;
  align-items: center;
  display: flex;
  justify-content: center;
  font-size: 1.1em;
}

.game .brief > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.game .brief > div > div {
  color: black !important;
}

.game .brief .badge {
  font-size: 0.55em;
  position: absolute;
  bottom: 5px;
  right: 5px;
  visibility: hidden;
}

.game .brief .today .badge {
  visibility: visible;
}

.game .brief h3 {
  margin: 1vh;
  color: #cd0402;
}
.game .brief .countdown {
  display: flex;
}

.game .logo:before,
.game .logo:after {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  content: " ";
}

.game .logo .border {
  border-left: 2px dashed #000;
  width: 1px;
  position: absolute;
  top: 5px;
  bottom: 5px;
  right: 0px;
  opacity: 0.15;
}

.game .logo:before {
  top: -5px;
  right: -5px;
}

.game .logo:after {
  bottom: -5px;
  right: -5px;
}

.game .brief:before,
.game .brief:after {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #fff;
  content: " ";
}

.game .brief:before {
  top: -5px;
  left: -5px;
}

.game .brief:after {
  bottom: -5px;
  left: -5px;
}

.game:before,
.game:after {
  content: " ";
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
}

.game:before {
  border-style: solid;
  border-width: 0px 0px 0px 8px;
  -moz-border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  -webkit-border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  -o-border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  left: -1px;
}

.game:after {
  border-style: solid;
  border-width: 0px 8px 0px 0px;
  -moz-border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  -webkit-border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  -o-border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  border-image: url(../../images/ui/dotted.png) 6 8 10 8 repeat round;
  right: -1px;
}
</style>

<script>
import {
  IonPage,
  IonContent,
  IonSlides,
  IonSlide,
  IonIcon,
  IonRippleEffect,
  IonBadge,
  IonFooter,
  IonToolbar,
  IonButtons,
  IonButton,
  IonLabel,
  // IonImg,
} from "@ionic/vue";
import SupportButton from "@/components/SupportButton.vue";
import Header from "@/components/Header.vue";
import { useRouter } from "vue-router";
import { defineComponent } from "vue";
// import { timeOutline } from 'ionicons/icons';
import authService from "@/services/auth";
import { timeOutline } from "ionicons/icons";
import { cloneDeep } from "lodash";

import TabBar from "@/components/TabBar.vue";
import { Plugins } from '@capacitor/core';

export default defineComponent({
  name: "Main",
  components: {
    IonContent,
    Header,
    IonPage,
    IonSlides,
    IonSlide,
    IonIcon,
    IonRippleEffect,
    IonBadge,
    TabBar,
    IonFooter,
    SupportButton,
    IonToolbar,
    IonButtons,
    IonButton,
    IonLabel,
    // IonImg,
  },
  computed: {
    isLogin() {
      return authService.user() && !authService.user().isAnonymous;
    },
    isAppLive() {
      return this.$store.state.fsdb.liveConfig[this.$utils.platform].live;
    },
    totalBalance() {
      if (!this.isLogin) return 0;

      if (!this.$store.state.fsdb.customer) return 0;

      return (
        this.$store.state.fsdb.customer.deposit +
        this.$store.state.fsdb.customer.bonus +
        this.$store.state.fsdb.customer.win
      );
    },
    greeting() {
      let name = this.$store.state.auth.fullName.split(' ').pop().trim();
      if (name.length == 0 || name.length > 7 || !this.$store.state.auth.title || this.$store.state.auth.title.trim().length == 0) {
        name = "quý khách";
      } else  {
        name = this.$store.state.auth.title + " " + name.toLowerCase().replace(/^./, m => m.toUpperCase());
      }
      name = name.replace(/^./, m => m.toUpperCase());
      return "Chào " + name + ",";
    },
  },
  async ionViewDidEnter() {
    this.$utils.hideLoading();
    console.log("main will enter");
    this.banners = cloneDeep(this.$store.state.homeBanners);

    console.log('banners', this.banners );

    if (!authService.binded) {
      await authService.bindFirestore();
    }

    this.$utils.callAPI2("GET", "/api/banners", null, false).then((resp) => {
      if (resp && resp.data) {
        this.$store.commit('updateHomeBanners', resp.data);
      }

      if (this.banners && this.banners.length ==0 && resp && resp.data && resp.data.length >0) {
        this.banners = resp.data;
      }

      setTimeout(() => {
        if (this.banners && this.banners.length > 0)
          this.$nextTick(() => {
            if (this.$refs.slider && this.$refs.slider.$el) {
              this.$refs.slider.$el.getSwiper().then((instance) => {
                setTimeout(() => {
                  instance.init();
                  instance.slideReset();
                  instance.update();
                  instance.slideTo(0);
                }, 1);
              });
            }
          });
      }, 1);
    }).catch( (error) => {
      console.log(error);
    });

    this.loaded = true;

    this.countdown = setInterval(() => {
      if (authService.binded) {
        const powerDuration = this.$moment.duration(
          this.$store.state.fsdb.livePower.draw_time - this.$moment.utc()
        );
        const megaDuration = this.$moment.duration(
          this.$store.state.fsdb.liveMega.draw_time - this.$moment.utc()
        );
        const max3dDuration = this.$moment.duration(
          this.$store.state.fsdb.liveMax3d.draw_time - this.$moment.utc()
        );
        const max3dproDuration = this.$moment.duration(
          this.$store.state.fsdb.liveMax3dpro.draw_time - this.$moment.utc()
        );
        const max4dDuration = this.$moment.duration(
          this.$store.state.fsdb.liveMax4d.draw_time - this.$moment.utc()
        );

        if (powerDuration.asMilliseconds() <= 0) {
          this.powerCountDown = "Đang xổ";
        } else {
          this.powerCountDown =
            Math.floor(powerDuration.asHours()) +
            this.$moment.utc(powerDuration.asMilliseconds()).format(":mm:ss");
        }

        if (megaDuration.asMilliseconds() <= 0) {
          this.megaCountDown = "Đang xổ";
        } else {
          this.megaCountDown =
            Math.floor(megaDuration.asHours()) +
            this.$moment.utc(megaDuration.asMilliseconds()).format(":mm:ss");
        }

        if (max3dDuration.asMilliseconds() <= 0) {
          this.max3dCountDown = "Đang xổ";
        } else {
          this.max3dCountDown =
            Math.floor(max3dDuration.asHours()) +
            this.$moment.utc(max3dDuration.asMilliseconds()).format(":mm:ss");
        }

        if (max3dproDuration.asMilliseconds() <= 0) {
          this.max3dproCountDown = "Đang xổ";
        } else {
          this.max3dproCountDown =
            Math.floor(max3dproDuration.asHours()) +
            this.$moment
              .utc(max3dproDuration.asMilliseconds())
              .format(":mm:ss");
        }

        if (max4dDuration.asMilliseconds() <= 0) {
          this.max4dCountDown = "Đang xổ";
        } else {
          this.max4dCountDown =
            Math.floor(max4dDuration.asHours()) +
            this.$moment.utc(max4dDuration.asMilliseconds()).format(":mm:ss");
        }

        if (powerDuration.asMinutes() <= 1065) {
          this.todayPower = "today";
        } else {
          this.todayPower = "";
        }
        if (megaDuration.asMinutes() <= 1065) {
          this.todayMega = "today";
        } else {
          this.todayMega = "";
        }
        if (max3dDuration.asMinutes() <= 1065) {
          this.todayMax3d = "today";
        } else {
          this.todayMax3d = "";
        }
        if (max3dproDuration.asMinutes() <= 1065) {
          this.todayMax3dpro = "today";
        } else {
          this.todayMax3dpro = "";
        }
        if (max4dDuration.asMinutes() <= 1065) {
          this.todayMax4d = "today";
        } else {
          this.todayMax4d = "";
        }
      }
    }, 1000);
  },
  ionViewWillLeave() {
    if (this.countdown)
      clearInterval(this.countdown);
    this.loaded = false;
    console.log("main leave");
  },
  data() {
    return {
      countdown: null,
      megaCountDown: "",
      powerCountDown: "",
      max3dCountDown: "",
      max3dproCountDown: "",
      max4dCountDown: "",
      todayPower: "",
      todayMega: "",
      todayMax3d: "",
      todayMax3dpro: "",
      todayMax4d: "",
      games: [
        {
          id: "keno",
          title: "Keno",
          bgcolor: "",
          fgcolor: "",
        },
        {
          id: "power",
          title: "Power 6/55",
          bgcolor: "",
          fgcolor: "",
        },
        {
          id: "mega",
          title: "Mega 6/45",
          bgcolor: "",
          fgcolor: "",
        },
        {
          id: "max3d",
          title: "Max3D",
          bgcolor: "",
          fgcolor: "",
        },
        {
          id: "max3dpro",
          title: "Max3D PRO",
          bgcolor: "",
          fgcolor: "",
        },
        // {
        //   id: 'max4d',
        //   title: 'Max4D',
        //   bgcolor: '',
        //   fgcolor: '',
        // },
        // {
        //   id: 'xskt',
        //   title: 'XSKT',
        //   bgcolor: '',
        //   fgcolor: '',
        // },
      ],
      slideImages: [],
      loaded: false,
      banners: [],
    };
  },
  setup() {
    const router = useRouter();
    return {
      router,
      jackpot(val) {
        const ret = Math.floor(val / 100000000) / 10;
        return (
          ret.toLocaleString("vi-VN", { maximumFractionDigits: 1 }) + " tỷ"
        );
      },
      async bannerClick(url) {
        const { Browser } = Plugins;
        if (url)
          await Browser.open({
            url: url
          });
      },
      slideOpts: {
        initialSlide: 0,
        speed: 400,
        init: false,
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 10,
      },
      timeOutline,
      authService,
    };
  },
  methods: {
    selectGame(id) {
      if (!this.isAppLive) {
        this.$router.push("/results/" + id);
        return;
      }
      this.$router.push("/" + id);
    },
  }
});
</script>
